import { Component, inject } from '@angular/core';
import { IconComponent } from '@app2/shared/components/icon/icon.component';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Store } from '@ngrx/store';
import { SubscribeBannerComponent } from '@app2/shared/components/subscribe-banner/subscribe-banner.component';
import { FapsStore } from '@app2/store/faps/faps.store';

@Component({
  selector: 'sens-aside-bar',
  imports: [
    IconComponent,
    RouterLinkActive,
    RouterLink,
    SubscribeBannerComponent,
  ],
  templateUrl: './aside-bar.component.html',
  standalone: true,
})
export class AsideBarComponent {
  private readonly store = inject(Store);

  private readonly fapsStore = inject(FapsStore);

  onOpenFeed(): void {
    this.fapsStore.loadByQuery({ p:1, defaultList: true });
  }
}
